export const USE_GET_WHEATHER = 'use_get_wheater';

export const KEY_OPEN_WHEATHER_MAP = 'c9d89360cde61d10e5f4bf2295d43418';
export const KEY_IPSTACK = '1cdbfababe03fe3131300e71d0a0025a';
